import { createContext, useContext } from 'react';
import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { jsx as _jsx } from "react/jsx-runtime";
const TRELLIS_BY_DEFAULT_GATE = gate('Breeze:Renderers:TrellisByDefault');

/** True inside a wrapper that rendered its foundations version. */
const FoundationsTreeContext = /*#__PURE__*/createContext(false);

/**
 * Whether callers that don't pass `trellisComponents` get trellis. Gate state
 * can't be read before user info loads or on pages without a portal, so those
 * keep the foundations default.
 */
export const getIsTrellisByDefault = () => {
  try {
    return userInfoSync().gates.includes(TRELLIS_BY_DEFAULT_GATE);
  } catch (_unused) {
    return false;
  }
};
/**
 * Renders a wrapper's trellis or foundations version. An explicit
 * `trellisComponents` wins. Without one, a wrapper inside a foundations tree
 * stays foundations, so `trellisComponents={false}` keeps a whole tree on
 * foundations; otherwise the default follows `Breeze:Renderers:TrellisByDefault`.
 */
const TrellisSwitch = ({
  trellisComponents,
  trellis,
  foundations
}) => {
  const isInFoundationsTree = useContext(FoundationsTreeContext);
  const useTrellis = trellisComponents !== null && trellisComponents !== void 0 ? trellisComponents : !isInFoundationsTree && getIsTrellisByDefault();
  if (useTrellis) {
    return trellis;
  }
  return /*#__PURE__*/_jsx(FoundationsTreeContext.Provider, {
    value: true,
    children: foundations
  });
};
export default TrellisSwitch;